import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/main_globalPermissionsAndGrantsQuery.graphql';

export const globalPermissionsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-global-permissions" */ './src/ui/main.tsx'),
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		queries: {
			main_globalPermissionsAndGrantsQuery: {
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
